import { MinimalMediaTarget } from './minimal_target';
import { MediaManager } from './media_manager';

type MediaItem = {
   data: any;
   toWikiText: () => string;
};

type AcceptsFilter = 'profile_image' | 'wiki_media';

/**
 * Open the Media Manager and resolve with the chosen item. Note: matching
 * the original behavior, the promise never settles when the user cancels.
 *
 * MediaManager.browse() transparently routes to the React Media Manager v2
 * when the mediaManagerV2 flag is on (see media_manager.js); the chosen item
 * arrives here as a legacy MediaItem either way, so consumers don't branch.
 */
export const activateMediaManager = (accepts: AcceptsFilter): Promise<MediaItem> =>
   new Promise<MediaItem>(resolve => {
      const target = new MinimalMediaTarget({
         customAttach: (mediaItem: MediaItem, finished: any) => {
            if (mediaItem) {
               resolve(mediaItem);
            }
            // Finished expects the old media item in the case of mutation
            // and a success boolean.
            finished(null, true);
         },
         accepts,
      });
      // cast to any because ts does not see the 'browse' event on the state machine (see media_manager.js)
      (MediaManager as any).browse(target);
   });
